import { render } from "./AtivaliveForm.vue?vue&type=template&id=f6b2340a&scoped=true"
import script from "./AtivaliveForm.vue?vue&type=script&lang=js"
export * from "./AtivaliveForm.vue?vue&type=script&lang=js"

import "./AtivaliveForm.vue?vue&type=style&index=0&id=f6b2340a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b2340a"]])

export default __exports__